import api from "../../api/api";

const token = localStorage.getItem("access");

let productCommentsCache: { [key: string]: any[] } = {};
let productCommentsCacheTime: { [key: string]: number } = {};
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const requiredComment = async () => {
    const response = await api.get(`/required-comments/`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const createComment = async (data: any) => {
    const response = await api.post(`/comments/`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const getComment = async () => {
    const response = await api.get(`/comments/`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const getCommentById = async (id: number) => {
    const response = await api.get(`/comments/${id}/`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const updateComment = async (id: number, data: any) => {
    const response = await api.put(`/comments/${id}/`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const productComment = async (id: any) => {
    const now = Date.now();
    const cacheKey = id.toString();

    if (productCommentsCache[cacheKey] && (now - productCommentsCacheTime[cacheKey]) < CACHE_DURATION) {
        return productCommentsCache[cacheKey];
    }

    try {
        const response = await api.get(`/product-comments/${id}/`);
        productCommentsCache[cacheKey] = response.data;
        productCommentsCacheTime[cacheKey] = now;
        return response.data;
    } catch (error: any) {
        // Unauthorized bo‘lsa ham token yo‘qligi sababli bu qism kerak emas,
        // ammo xavfsizlik uchun shunchaki qayta ishlaymiz
        if (error.response?.status === 401) {
            return [];
        }
        throw error;
    }
};
